import { createAsyncThunk } from "@reduxjs/toolkit";
import ExpertRevenueManagementService from "services/expertRevenueHistory";
import { LessonsRevenuePayload } from "../models/revenue";

export const getExpertLessonRevenueHistory = createAsyncThunk(
  "get/expertLessonHistory",
  async (data: LessonsRevenuePayload, { rejectWithValue, dispatch }) => {
    try {
      const response =
        await ExpertRevenueManagementService.getLessonsRevenueHistory(data);
      return {
        totalPoints: response?.data?.total_amount,
        startDate: response?.data?.start_date,
        endDate: response?.data?.end_date,
        lessonHistory: response?.data?.pointList?.map((lessonHistory: any, index: number) => {
          return {
            id: index,
            date: lessonHistory?.date,
            lessonName: lessonHistory.lesson_data.lesson_name
              + " | "
              + lessonHistory.lesson_data.sub_lesson_name,
            revenueHistoryItemStudentList: lessonHistory.point_history.map((pointHistory: any) => {
              return {
                avatar: pointHistory.user_avatar,
                points: pointHistory.amount,
                userName: pointHistory.user_name
              };
            })
          };
        })
      };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getExpertPaymentHistory = createAsyncThunk(
  "get/expertPaymentHistory",
  async (data: LessonsRevenuePayload, { rejectWithValue, dispatch }) => {
    try {
      const response = await ExpertRevenueManagementService.getPaymentHistory(
        data
      );
      return response.data?.data?.map((paymentHistoryItem: any) => {
        return {
          id: paymentHistoryItem.id,
          date: paymentHistoryItem.created_at,
          totalAmount: paymentHistoryItem.total_amount,
          bankFee: paymentHistoryItem.bank_fees,
          status: paymentHistoryItem.status,
          referenceNo: paymentHistoryItem.reference_no
        };
      });
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
